import React from "react";
import { TbFileDownload } from "react-icons/tb";

const InvoiceDownloadNew = ({ invoiceId }) => {
  console.log(invoiceId, " ++++++++++++++invoiceId+++++++++")
  const handleDownload = async () => {
    try {
      const response = await fetch(
        `https://riymay.com/api/v1/user/download/invoice/${invoiceId}`, 
        // `riymay.com/api/v1/user/download/invoice/67c5ec9d3efc0de82a1a79c8`

        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("userToken")}`,
            "Content-Type": "application/pdf",
          },
        }
      );

      if (!response.ok) {
        throw new Error("Failed to download invoice");
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `invoice-${invoiceId}.pdf`; // Dynamic filename
      document.body.appendChild(a);
      a.click();
      a.remove();
    } catch (error) {
      console.error("Error downloading the invoice:", error);
    }
  };

  return (
    <button
      onClick={handleDownload}
      className="order-history-invoice-dow-button"
    >
      Download Invoice <TbFileDownload />

    </button>
  );
};

export default InvoiceDownloadNew;
